// SPV Pool v1.0 PR 6 — Section E. Always rendered at the top of the Cash
// Flow tab, above the period selector. In v1.0 no accounting integration
// is wired, so this is a static "not connected" notice. Warm-white bg,
// onyx text, gold accent border.

import { PlugZap } from "lucide-react";
import { formatDate, humanizeStatus } from "../../../shared/format";
import type { AccountingStatusDto } from "@/types/spvPool";

interface AccountingBannerProps {
  status?: AccountingStatusDto;
}

export function AccountingBanner({ status }: AccountingBannerProps) {
  const connected = status?.isConnected ?? false;

  return (
    <div className="flex flex-wrap items-start justify-between gap-space-3 border-l-[3px] border-gold bg-white-warm text-onyx p-space-3 rounded-md">
      <div className="flex items-start gap-space-2">
        <PlugZap
          size={16}
          strokeWidth={1.5}
          className="mt-[2px] text-gold-shadow shrink-0"
          aria-hidden
        />
        <div>
          {connected ? (
            <p className="text-small m-0">
              Accounting integration: connected
              {status?.providerName ? ` to ${status.providerName}` : ""}.
              {status?.lastSyncAt
                ? ` Last sync ${formatDate(status.lastSyncAt)}`
                : ""}
              {status?.lastSyncStatus
                ? ` (${humanizeStatus(status.lastSyncStatus)})`
                : ""}
              .
            </p>
          ) : (
            <p className="text-small m-0">
              Accounting integration: not connected. Cash flow is computed
              from internal records only.
            </p>
          )}
        </div>
      </div>
      <p className="text-caption text-gray-mid m-0 max-w-xs">
        When QuickBooks or Sage is wired, this banner shows the last sync
        status.
      </p>
    </div>
  );
}
